import React, { Fragment, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updateSignUpData, signUp } from "../../../store/reducers/signUpSlice";
import { loginUser } from "../../../store/reducers/authSlice";
import * as Yup from "yup";
import logo from "../../../assets/media/logo.png";
import booksAnimation from "../../../assets/media/books-animation.gif";
import GamingBoardBahamasLogo from "../../../assets/media/GamingBoardBahamasLogo.png";
import GBInput from "../../input";
import { showError } from "../../../helpers/toast";

const SignUp2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signUpUser = useSelector((state) => state.signUp);
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.signUp.loading);
  const signupData = useSelector((state) => state?.signUp?.data?.payload);

  console.log(user, "signup-data");

  const initialValues = {
    phone: user?.phone || "",
    companyRegistrationNo: user?.company?.company_id || "",
  };

  const validationSchema = Yup.object({
    phone: Yup.string().required("Phone Number is required"),
    // .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Invalid phone number format'),
    companyRegistrationNo: Yup.string(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      console.log({ values });
      const updatedData = {
        signupcode: signUpUser.signupcode,
        password: signUpUser.password,
        full_name: signUpUser.full_name,
        phone: values.phone,
        companyRegistrationNo: values.companyRegistrationNo,
      };

      dispatch(updateSignUpData(updatedData));

      if (signUpUser?.signupcode) {
        // Bypass step 3 - directly complete signup
        try {
          const signupResponse = await dispatch(
            signUp({
              userData: updatedData,
            })
          ).unwrap();

          // Auto-login after successful signup
          // Get email from the response or from user state
          const userEmail = signupResponse?.user?.email || signUpUser?.message?.user?.email || user?.email;

          if (userEmail) {
            dispatch(
              loginUser(
                {
                  emailOrPhone: userEmail,
                  password: updatedData.password,
                },
                navigate
              )
            );
          } else {
            navigate("/");
          }
        } catch (error) {
          console.error("Signup error:", error);
          // Check if error is related to invalid signup code
          const errorMessage = error?.message || error?.response?.data?.error || "";
          if (
            errorMessage.toLowerCase().includes("invalid signuo code") ||
            errorMessage.toLowerCase().includes("invalid signup code")
          ) {
            showError("The link is expired. Please contact the service provider.");
          } else {
            showError(errorMessage || "Failed to complete signup");
          }
        }
      }
    },
  });
  const { values, handleChange, handleSubmit, errors } = formik;

  const fields = [
    {
      name: "phone",
      label: "Phone Number",
      type: "tel",
      placeholder: "(702) 555-0122",
      value: values.phone,
      onChange: handleChange,
      disabled: true,
    },
    ...(user?.user_role === "company_admin"
      ? [
        {
          name: "companyRegistrationNo",
          label: "Company Registration No.",
          type: "text",
          placeholder: "Enter Company Registration No.",
          value: values.companyRegistrationNo,
          readOnly: user?.company?.company_id ? true : false,
          onChange: handleChange,
        },
      ]
      : []),
  ];

  useEffect(() => {
    if (!signUpUser?.access_token) {
      // navigate('/signup-step1');
    }
  }, [navigate, signUpUser?.access_token]);

  // Redirect if already logged in
  useEffect(() => {
    if (user?.access_token || signupData?.access_token) {
      navigate("/");
    }
  }, [navigate, user, signupData]);

  return (
    <div className="App">
      <div className="container">
        <div className="landingWrapper">
          <div className="landingRow">
            <div className="landingCol">
              <div className="fieldsWrapper">
                <img src={logo} className="logo" alt="logo" />
                <h2>Sign Up With Us</h2>
                <p>
                  Welcome to the Gaming Board of The Bahamas Digital Application Portal.
                </p>
                <form className="gb-login-form" onSubmit={handleSubmit}>
                  {fields.map((field, index) => {
                    return (
                      <Fragment key={index}>
                        <GBInput
                          name={field.name}
                          type={field.type}
                          label={field.label}
                          value={field.value}
                          placeholder={field.placeholder}
                          setValue={handleChange}
                          readOnly={field.readOnly}
                          disabled={field.disabled}
                        />
                        {errors[`${field.name}`] && (
                          <div className="error-message error-message-wrap">
                            {errors[`${field.name}`]}
                          </div>
                        )}
                      </Fragment>
                    );
                  })}
                  <div className="gb-form-footer">
                    <button type="submit" className="form-submit" disabled={loading}>
                      {loading ? (
                        <>
                          <div
                            className="text-xs spinner-border text-light"
                            style={{ width: "1rem", height: "1rem" }}
                            role="status"
                          ></div>
                          <span className="sr-only ml-5"> Loading...</span>
                        </>
                      ) : (
                        "Sign Up"
                      )}
                    </button>
                  </div>
                </form>
                <div className="gb-step-list">
                  <span className="current"></span>
                  <span className="current"></span>
                </div>
              </div>
            </div>
            <div className="landingCol">
              <div className="imageWrapper">
                <div className="loginBox">
                  <p>
                    Already have account? <Link to={"/"}>Sign In</Link>
                  </p>
                </div>
                <img width={"300px"} height={"300px"} src={GamingBoardBahamasLogo} className="booksAnimation" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp2;
